import React, { Component } from 'react';

class FeaturesV1 extends Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        let cushrefmClass = this.props.cushrefmClass ? this.props.cushrefmClass : '';

        return (
            <div className={cushrefmClass}>
                <div id='services' className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title-area ltn__section-title-2--- text-center">
                                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                                    Nos Services & Avantages
                                </h6>
                                <h1 className="section-title">Vivre l’excellence immobilière</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row ltn__cushrefm-gutter--- justify-content-center go-hrefp">
                        {/* Sécurité & Commodités */}
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white box-shadow-1">
                                <div className="ltn__feature-icon">
                                    <img src={publicUrl + "assets/img/icons/icon-img/22.png"} alt="Sécurité et Commodités" />
                                </div>
                                <div className="ltn__feature-info">
                                    <h3><a href="#services">Sécurité & Commodités</a></h3>
                                    <p>
                                        Résidence sécurisée 24h/24, parkings souterrains, accès contrôlé, vidéosurveillance, local commercial en rez-de-chaussée, ascenseur moderne, espaces verts et aire de jeux pour enfants, pour une vie sereine et confortable au quotidien.
                                    </p>
                                    <a className="ltn__service-btn" href="#contact">
                                        En savoir plus <i className="flaticon-right-arrow" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* Acheter un appartement */}
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white box-shadow-1 active">
                                <div className="ltn__feature-icon">
                                    <img src={publicUrl + "assets/img/icons/icon-img/21.png"} alt="Acheter appartement" />
                                </div>
                                <div className="ltn__feature-info">
                                    <h3><a href="#contact">Acheter un appartement</a></h3>
                                    <p>
                                        Appartements lumineux de 2 chambres + salon, entre 60 et 70 m², finitions haut standing, cuisine équipée, isolation phonique, parking privé et architecture contemporaine, au cœur d’un quartier calme et accessible de Tanger.
                                    </p>
                                    <a className="ltn__service-btn" href="#contact">
                                        Découvrir <i className="flaticon-right-arrow" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* Accompagnement personnalisé */}
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white box-shadow-1">
                                <div className="ltn__feature-icon">
                                    <img src={publicUrl + "assets/img/icons/icon-img/23.png"} alt="Accompagnement personnalisé" />
                                </div>
                                <div className="ltn__feature-info">
                                    <h3><a href="#contact">Accompagnement personnalisé</a></h3>
                                    <p>
                                        Conseils sur-mesure, assistance au financement, gestion locative, service après-vente dédié, suivi personnalisé et transparence à chaque étape, pour un achat en hrefute tranquillité et une satisfaction hreftale.
                                    </p>
                                    <a className="ltn__service-btn" href="#contact">
                                        Contactez-nous <i className="flaticon-right-arrow" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FeaturesV1;
